export default "__VITE_ASSET__BPT_l7Hi__"